import {
    ADD_TENANT, UPDATE_TENANT, DELETE_TENANT,
    FETCH_PROPERTY_TENANTS, BULK_UPLOAD, 
    DELETE_PROPERTY, DELETE_UNIT, LOAD_PROPERTIES_UNITS_TENANTS, 
    FETCH_TRANSACTIONS,
    FETCH_TENANTS,
    LOG_OUT_USER,
    SHIFT_TENANT,
    ADD_INVOICE, UPDATE_INVOICE
} from '../../actions/actionTypes';


const fetchTenantsReducer = (tenants, payload) => {
    let newTenants = payload.offset == "" ? {} : { ...tenants };
    for(let tenant of payload.tenants){
        newTenants[tenant.tenantId] = tenant;
    }
    return newTenants;
}

const addTenantReducer = (tenants, payload) => {
    let newTenants = { ...tenants};
    newTenants[payload.tenantId] = {
        ...payload
    };
    return newTenants;   
}

const updateTenantReducer = (tenants, payload) => {
    let newTenants = {...tenants};
    newTenants[payload.tenantId] = { ...payload };
    return newTenants;

}

const deleteTenantReducer = (tenants, payload) => {
    let newTenants = {...tenants};
    delete newTenants[payload.tenantId];
    return newTenants;
}

const deletePropertyTenantsReducer = (tenants, payload) => {
    let newTenants = {...tenants};
    for (const [key, value] of Object.entries(newTenants)) {
        if (value.propertyId == payload.propertyId){
            delete newTenants[value.tenantId];
        }
    }
    return newTenants;
}

const deleteUnitTenantsReducer = (tenants, payload) => {
    let newTenants = {...tenants};
    for (const [key, value] of Object.entries(newTenants)) {
        if (value.unitId == payload.unitId){
            delete newTenants[value.tenantId];
        }
    }
    return newTenants;
}


const fetchTransactionsReducer = (tenants, payload) => {
    let newTenants = { ...tenants };
    if (newTenants[payload.tenantId]){
        if (payload.accountBalance != null){
            newTenants[payload.tenantId].accountBalance = payload.accountBalance;
        }     
    }
    return newTenants;
}

const fetchPropertyTenantsReducer = (tenants, payload) => {
    let newTenants = { ...tenants };
    for(let tenant of payload.tenants){
        newTenants[tenant.tenantId] = tenant;
    }
    return newTenants;
}

const shiftTenantReducer =(tenants, payload) => {
    let newTenants = {...tenants};
    if (payload.success){
        // change the unit id of the tenant to the new unit in redux state
        newTenants[payload.tenantId] = payload.tenant
    }
    return newTenants;
}

const updateTenantBalanceFromInvoice = (tenants, payload) => {
    let newTenants = { ...tenants };
    if (payload.invoice && payload.invoice.tenant){
        const tenant = payload.invoice.tenant;
        if (tenant.tenantId in newTenants){
            newTenants[tenant.tenantId].accountBalance = tenant.accountBalance;
        }
    }
    return newTenants;
}

const tenantsReducer = (state={}, action) => {
    let  tenants = state;
    if (action.errors == null){
        switch(action.type){
            case FETCH_TENANTS:
                return fetchTenantsReducer(tenants, action.payload);
            case FETCH_PROPERTY_TENANTS:
                return fetchPropertyTenantsReducer(tenants, action.payload);
            case ADD_TENANT:
                return addTenantReducer(tenants, action.payload);
            case UPDATE_TENANT:
                return updateTenantReducer(tenants, action.payload);
            case DELETE_TENANT:
                return deleteTenantReducer(tenants, action.payload);
            case DELETE_PROPERTY:
                return deletePropertyTenantsReducer(tenants, action.payload);
            case DELETE_UNIT:
                return deleteUnitTenantsReducer(tenants, action.payload);
            case BULK_UPLOAD:
                return action.payload.tenants;
            case FETCH_TRANSACTIONS:
                return fetchTransactionsReducer(tenants, action.payload);
            case SHIFT_TENANT:
                return shiftTenantReducer(tenants, action.payload);
            case ADD_INVOICE:
                return updateTenantBalanceFromInvoice(tenants, action.payload);
            case UPDATE_INVOICE:
                return updateTenantBalanceFromInvoice(tenants, action.payload);  
            case LOG_OUT_USER:
                return {};
            default:
                return tenants;
        }
    }else{
        return tenants;
    }
};
export default tenantsReducer;